<div [ngClass]="type" class="dialog-container">
  <h2 class="dialog-title">
    @if (type === 'error') {
      <mat-icon color="warn">error</mat-icon>
    }
    @if (type === 'warning') {
      <mat-icon color="primary">warning</mat-icon>
    }
    @if (type === 'info') {
      <mat-icon color="primary">info</mat-icon>
    }
    {{ titleKey | transloco }}
  </h2>

  <!-- si descriptionKey est une string -->
  @if (descriptionAsString) {
    <p class="dialog-description">
      {{ descriptionAsString | transloco }}
    </p>
  }

  @if (descriptionAsArray.length) {
    <ul class="dialog-description-list">
      @for (msg of descriptionAsArray; track msg) {
        <li>
          {{ msg | transloco }}
        </li>
      }
    </ul>
  }


  <div class="dialog-actions">
    @if (cancelBtnKey) {
      <button (click)="close('cancel')"
        [mat-dialog-close]="{ action: 'cancel' }"
        data-testid="dialogMessageCancel"
        class="dialog-secondary-btn">
        {{ cancelBtnKey | transloco }}
      </button>
    }

    <button (click)="close('confirm')"
      [mat-dialog-close]="{ action: 'confirm' }"
      [ngClass]="type"
      data-testid="dialogMessageConfirm"
      class="dialog-primary-btn">
      {{ actionBtnKey | transloco }}
    </button>
  </div>
</div>
